import styled from "styled-components/macro";

export const Container = styled.div`
  input {
    margin-top: 2em;
    padding: 3px;
    width: 100%;
  }
`;
